<template>
  <b-modal title="Informações Sobre o Documento" v-model="show" size="lg">
    <b-container fluid>
      <b-row class="mt-2">
        <b-col cols="11">
          <b-form-group label="Descrição:" label-for="descricao" label-cols-sm="3" label-align-sm="right">
            <b-form-input id="descricao" v-model="editing.descricao" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="11">
          <b-form-group label="Número:" label-for="numero" label-cols-sm="3" label-align-sm="right">
            <b-form-input id="numero" v-model="editing.numero" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="11">
          <b-form-group label="Tipo:" label-for="tipo" label-cols-sm="3" label-align-sm="right">
            <b-form-input id="tipo" v-model="editing.tipo" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="11">
          <b-form-group label-cols-sm="3" label="Data:" label-align-sm="right" label-for="data">
            <b-form-datepicker
              id="data"
              v-model="editing.data"
              :date-format-options="{
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
              }"
            ></b-form-datepicker>
          </b-form-group>
        </b-col>
      </b-row>
    </b-container>

    <template #modal-footer>
      <b-button variant="primary" @click="salvar()">Salvar</b-button>
      <b-button variant="secondary" @click="show = !show">Fechar</b-button>
    </template>
  </b-modal>
</template>

<script>
import Documento from "@/models/Documento";
import Notificacao from "@/models/Notificacao";
import { useSgcqStore } from "@/stores/SgcqStore";
import { useDocumentoStore } from "@/stores/DocumentoStore";

export default {
  name: "ModalDeEdicaoDeDocumento",

  data() {
    return {
      editing: new Documento(),
      show: false,
    };
  },

  methods: {
    salvar() {
      if (this.editing.id != 0) {
        this.documentoStore.ALTERAR_DOCUMENTO(this.editing).then(() => {
          this.store.NOTIFICAR(new Notificacao("Documento salvo no SGCQ com sucesso!", "Excelente!", "success"));
        });
      } else {
        this.documentoStore
          .CADASTRAR_DOCUMENTO(this.editing)
          .then(() => this.store.NOTIFICAR(new Notificacao("Documento salvo no SGCQ com sucesso!", "Excelente!", "success")));
      }
      this.show = !this.show;
    },

    call(documento) {
      this.editing = documento;
      this.show = !this.show;
    },
  },

  setup() {
    const store = useSgcqStore();
    const documentoStore = useDocumentoStore();

    return {
      store,
      documentoStore,
    };
  },
};
</script>

<style lang="scss" scoped></style>
